import React, { useEffect, useState } from "react";
import Table from "../../../Utils/Table/Table1";
import { getFundstatus } from "../../../Services/Admin/Addmin";
import { UpdatestatusForpaymenthistory, InrUpdatestatusForpaymenthistory, getScreenShot, InrgetScreenshot } from "../../../Services/Admin/Addmin";
import Swal from "sweetalert2";
import { fDateTime } from "../../../Utils/Date_format/datefromat";
import { Modal, Button } from "react-bootstrap";
import { getUserFromToken } from "../../../Utils/TokenVerify";

import { GetAdminUsername } from "../../../Services/Superadmin/Superadmin";
import { useLocation } from "react-router-dom";

const Deposit = () => {

  const state = useLocation()
  const TokenData = getUserFromToken();



  const [data, setData] = useState([]);
  const [activeTab, setActiveTab] = useState("Pending");
  const [selectedValues, setSelectedValues] = useState({});
  const [search, setSearch] = useState("");

  const [page, setPage] = useState(1);
  const [selectedAdminName, setSelectedAdminName] = useState("");
  const [adminNames, setAdminNames] = useState([]);
  const [activeMarket, setActiveMarket] = useState(
    state?.state?.item === "rupee" ? "INR" : "USD"
  );
  const [getimage, setGetimage] = useState({})
  const [imageModel, setImageModel] = useState(false)
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(1);




  useEffect(() => {
    getAdminNames();
    getAllfundsstatus();
  }, [activeTab, page, rowsPerPage, selectedAdminName, activeMarket, search]);

  const getAdminNames = async () => {
    try {
      const response = await GetAdminUsername();

      setAdminNames(response.data);
    } catch (error) { }
  };



  const getScreenShotdata = async (value) => {
    try {
      const data = { userid: value.userid, id: value._id };
      let response;

      if (activeMarket === "INR") {
        response = await InrgetScreenshot(data);
      } else {
        response = await getScreenShot(data);
      }

      setGetimage(response?.data?.ScreenShot);
      setImageModel(true);
    } catch (error) {
      console.error("Error fetching screenshot:", error);
    }
  };




  const columns = [
    { Header: "Name", accessor: "FullName" },

    {
      Header: "Balance",
      accessor: "UserBalance",
      Cell: ({ row }) => row.UserBalance?.toFixed(4),
    },
    { Header: "Transaction Id", accessor: "transactionId" },

    {
      Header: "Date",
      accessor: "createdAt",
      Cell: ({ row }) => fDateTime(row.createdAt),
    },
    {
      Header: "ScreenShot",
      accessor: "",
      Cell: ({ row }) => (
        <button
          className="btn btn-primary mx-3"
          onClick={() => getScreenShotdata(row)}
        >
          View
        </button>
      ),
    },
  ];


  const handleSelectChange = async (rowId, row, event) => {
    const newSelectedValues = {
      ...selectedValues,
      [rowId]: event.target.value,
    };
    setSelectedValues(newSelectedValues);
    await Updatestatus(row._id, newSelectedValues[rowId], row);
  };



  const Updatestatus = async (id, status, row) => {
    try {
      const data = { admin_id: selectedAdminName, id, status, type: "CREDIT", Balance: row.Balance };
      let response;
      if (activeMarket === "INR") {
        response = await InrUpdatestatusForpaymenthistory(data);
      } else {
        response = await UpdatestatusForpaymenthistory(data);
      }

      if (response.status) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text:
            response.message ||
            "An unexpected error occurred. Please try again.",
          timer: 3000,
        });
        getAllfundsstatus();
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text:
            response.message ||
            "Failed to update the request. Please try again.",
          timer: 2000,
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text:
          error.message || "An unexpected error occurred. Please try again.",
        timer: 2000,
      });
    }
  };




  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  ;


  const getAllfundsstatus = async () => {
    try {
      if (!selectedAdminName) {
        setData([]);
        return;
      }

      const reqData = {
        adminid: selectedAdminName,
        type: 1,
        activeTab,
        market: activeMarket,
        search,
        page,
        limit: rowsPerPage
      };

      const response = await getFundstatus(reqData);

      if (response.status) {
        setData(response.data || []);
        setTotalPages(response.pagination?.totalRecords || 1);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const filterDataBySearch = (data) => {
    if (!search) return data;
    return data.filter((item) =>
      item.FullName.toLowerCase().includes(search.toLowerCase())
    );
  };




  const renderTable = (status) => {

    const filteredData = filterDataBySearch(data);

    const handlePageChange = (newPage) => {
      setPage(newPage);
    };

    const handleRowsPerPageChange = (newLimit) => {
      setRowsPerPage(newLimit);
      setPage(1); // new limit → go to page 1
    };


    return (
      <div className="table-responsive"  >
        <div className="row align-items-center gap-3 mb-4 ms-2 mt-2 " >
          <div className="col-lg-4">
            <label htmlFor="searchInput" className="form-label">
              🔍 Search:
            </label>
            <input
              id="searchInput"
              className="form-control "
              type="text"
              placeholder="Search..."
              value={search}
              onChange={(e) => {
                setSearch(e.target.value);
                setPage(1);
              }}

            />
          </div>


          <div className="col-lg-4">
            <label htmlFor="userSelect" className="form-label">
              Admins:
            </label>
            <select
              id="userSelect"
              className="form-select "
              style={{
                borderRadius: "10px",
                padding: "9px",
                borderColor: "#ced4da",
                cursor: "pointer",
              }}
              value={selectedAdminName}
              onChange={(e) => setSelectedAdminName(e.target.value)}
            >
              <option value="">Select User</option>
              {adminNames?.map((item, index) =>
                item ? (
                  <option value={item._id} key={index}>
                    {item.UserName}
                  </option>
                ) : null
              )}
            </select>
          </div>
        </div>
        <h5 className="mb-3 ms-4 fw-semibold">{activeTab} Transactions</h5>
        <Table
          columns={columns}
          data={data}
          page={page}
          totalPages={totalPages}
          initialRowsPerPage={rowsPerPage}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleRowsPerPageChange}
        />

      </div>
    );
  };



  return (
    <div>
      <div className="row">
        <div className="demo-view">
          <div className="container-fluid mt-5">
            <div className="row">
              <div className="col-xl-12">
                <div className="card dz-card" id="nav-pills" style={{ background: "#F7F7F7" }}>
                  <div className="card-header flex-wrap border-0">
                    <h4 className="card-title">🏦 Deposit History</h4>
                    <div className="wallet-tabs">
                      <div className="btn-group py-1" role="group">
                        {TokenData?.market.includes(0) && (
                          <button
                            type="button"
                            className={`btn ${activeMarket === "USD"
                              ? "btn-primary"
                              : "btn-outline-primary"
                              }`}
                            onClick={() => setActiveMarket("USD")}
                          >
                            <i className="fas fa-dollar-sign me-2"></i>
                            USD Wallet
                          </button>
                        )}

                        {TokenData?.market.includes(1) && (
                          <button
                            type="button"
                            className={`btn ${activeMarket === "INR"
                              ? "btn-primary"
                              : "btn-outline-primary"
                              }`}
                            onClick={() => setActiveMarket("INR")}
                          >
                            <i className="fas fa-rupee-sign me-2"></i>
                            INR Wallet
                          </button>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="card-body pt-0 mt-4">
                    {/* Nav Pills */}
                    {/* <ul className="nav nav-pills nav-pills1 mb-4 light">
                      {["Pending", "Complete", "Reject"].map((tab, index) => (
                        <li className="nav-item" key={tab}>
                          <a
                            href={`#navpills-${index + 1}`}
                            className={`nav-link navlink ${activeTab === tab ? "active" : ""
                              }`}
                            data-bs-toggle="tab"
                            onClick={() => handleTabClick(tab)}
                          >
                            {tab}
                          </a>
                        </li>
                      ))}
                    </ul> */}
                    <ul className="seg-tabs w-full">
                      {["Pending", "Complete", "Reject"].map((tab) => (
                        <li
                          key={tab}
                          className={`seg-item ${activeTab === tab ? "active" : ""}`}
                          onClick={() => handleTabClick(tab)}
                          role="button"
                        >
                          {tab}
                        </li>
                      ))}
                    </ul>

                    {/* Tab Content */}
                    <div className="tab-content">
                      {["Pending", "Complete", "Reject"].map((tab, index) => (
                        <div
                          key={tab}
                          id={`navpills-${index + 1}`}
                          className={`tab-pane ${activeTab === tab ? "active" : ""
                            }`}
                        >
                          <div className="row">
                            <div className="col-lg-12">
                              <div className="card transaction-table">
                                <div className="card-body pt-0">
                                  {/* Render Table */}
                                  {renderTable(index)}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal
        show={imageModel}
        onHide={() => setImageModel(false)}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Screenshot</Modal.Title>
        </Modal.Header>

        <Modal.Body className="overflow-auto" style={{ maxHeight: "70vh" }}>
          {getimage.length > 0 ? (
            <img
              src={getimage?.startsWith("data:image") ? getimage : `data:image/png;base64,${getimage}`}
              alt="Screenshot"
              className="img-fluid rounded"
            />
          ) : (
            <p>No image available</p>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setImageModel(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

    </div>
  );
};


export default Deposit;
